import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useEffect } from 'react'
import React from 'react'

import useMemberInfo from '../../hooks/useMemberInfo'
import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import Backdrop from '../common/backdrop'
import Icon from '../icon'
import Avatar from './avatar'
import Footer from './footer'
import LanguageSelector from './language-selector'
import LoginSignUp from './login-sign-up'
import Tabs from './tabs'
import ThemeSwitch from './theme-switch'
import VipLevel from './vip-level'

const ProfileDrawer = () => {
  const { refreshMemberInfo } = useMemberInfo()
  const username = useBoundStore(state => state.user.username)
  const modal = useModal()

  useEffect(() => {
    if (!username) return
    refreshMemberInfo()
  }, [])

  return (
    <>
      <Backdrop
        zIndex={150}
        isVisible={modal.visible}
        onClick={() => closeModal(modal)}
        id="profile-drawer"
      />
      <div
        className={classNames(
          'fixed z-[160] bg-primary animate-slideRight w-[330px] h-screen overflow-y-auto overflow-x-hidden pb-[125px] top-0',
          modal.visible
            ? 'pointer-events-auto opacity-100 left-0'
            : 'pointer-events-none opacity-0 -left-full',
        )}>
        <div className="absolute z-[-1] left-0 -top-2.5">
          <Icon id="drawer-curtain" width="330" height="124" fill="#DF0033" />
        </div>
        <Avatar closeProfileDrawer={() => closeModal(modal)} />
        {username && <VipLevel closeProfileDrawer={() => closeModal(modal)} />}
        <Tabs
          closeProfileDrawer={() => closeModal(modal)}
          showProfileDrawer={() => modal.show()}
        />
        <Footer closeProfileDrawer={() => closeModal(modal)} />
        {!username && (
          <LoginSignUp closeProfileDrawer={() => closeModal(modal)} />
        )}
        <div className="border-b-[#f5f6f9] dark:border-b-[#1f223c] border-b border-solid" />
        <ThemeSwitch />
        <LanguageSelector />
      </div>
    </>
  )
}

export default NiceModal.create(ProfileDrawer)
